import { BrandCaptionLowerThirdEntity } from "@common/domain";
import { createAction, props } from "@ngrx/store";

export const brandCaptionLowerThirdCreateSuccess = createAction(
  "[Brand Caption Lower Third] Create Success",
  props<{ brandCaptionLowerThird: BrandCaptionLowerThirdEntity }>()
);

export const brandCaptionLowerThirdDeleteSuccess = createAction(
  "[Brand Caption Lower Third] Delete Success",
  props<{ brandCaptionLowerThird: BrandCaptionLowerThirdEntity }>()
);

export const brandCaptionLowerThirdUnUseSuccess = createAction(
  "[Brand Caption Lower Third] Un Use Success",
  props<{ brandCaptionLowerThird: BrandCaptionLowerThirdEntity }>()
);

export const brandCaptionLowerThirdUpdateSuccess = createAction(
  "[Brand Caption Lower Third] Update Success",
  props<{ brandCaptionLowerThird: BrandCaptionLowerThirdEntity }>()
);

export const brandCaptionLowerThirdUseSuccess = createAction(
  "[Brand Caption Lower Third] Use Success",
  props<{ brandCaptionLowerThird: BrandCaptionLowerThirdEntity }>()
);
